export default "__VITE_ASSET__8f37953c__"